<template>
  <modal
   :name="modalTitle"
   :adaptive="true"
   height="auto"
   :width="500"
   transition="linear"
   :delay="0.15"
  >
    <modals-header
      :modalNameProp="modalTitle"
      @hideModalProp="hideModal"
    >
    </modals-header>

    <hr class="v--modal-hr">

    <div class="fp-modal">
      <div>{{ text }}</div>
      <button
        type="button"
        class="generic-btn"
        @click="hideModal"
      >
        {{ $lang.messages.cancel }}
      </button>
      <button
        type="button"
        class="action-btn"
        @click="emitAction()"
      >
        <span>{{ buttonText }}</span>
      </button>
    </div>
  </modal>
</template>

<script>
  import { mapActions } from 'vuex';
  import { GET_PAYABLE_FROM } from "@/store/action.types";
  import modalsHeader from "@/components/common/modals/ModalsHeader";

  export default {
    name: "ConfirmationModal",
    components: {
      'modals-header': modalsHeader
    },
    props: {
      modalTitle: {
        type: String,
        required: false,
        default: () => ''
      },
      text: {
        type: String,
        required: false,
        default: () => ''
      },
      buttonText: {
        type: String,
        required: false,
        default: () => ''
      },
    },
    methods: {
      ...mapActions({
        GET_PAYABLE_FROM
      }),
      show() {
        this.$modal.show(this.modalTitle)
      },
      hideModal() {
        this.$modal.hide(this.modalTitle)
      },
      emitAction() {
        this.$emit("emitAction");
        this.$store.dispatch('GET_PAYABLE_FROM', true);
        this.hideModal()
      },
    }
  };
</script>
